import { Table, Input } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import Cookies from "js-cookie";
const OrderTable = () => {
  //todo -----------------Search-----------
  const [SearchText, setSearchText] = useState("");
  //todo----------------------------------------------
  const [dataSource, setDataSource] = useState([]);
  useEffect(() => {
    GetApiOrder();
  }, []);
  const GetApiOrder = async () => {
    const res = await axios.get(
      `https://bardawamplus.com/api/orders/store/${Cookies.get("store")}`
    );

    setDataSource(
      res.data.data.map((item) => {
        return {
          id: item.id,
          username: item.username,
          phone_number: item.phone_number,
          total_amount: item.total_amount,
          address: item.address,
        };
      })
    );
  };

  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",

      filteredValue: [SearchText],
      onFilter: (value, record) => {
        return (
          String(record.username).toLowerCase().includes(value.toLowerCase()) ||
          String(record.phone_number)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.id).toLowerCase().includes(value.toLowerCase())
        );
      },
    },
    {
      title: "username",
      dataIndex: "username",
      key: "username",
      render: (text, record) => (
        <Link to={`/OrderTable/OrderDetails/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: "total_amount",
      dataIndex: "total_amount",
      key: "total_amount ",
      render: (text, record) => (
        <Link to={`/OrderTable/OrderDetails/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: "phone_number",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (text, record) => (
        <Link to={`/OrderTable/OrderDetails/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: "address",
      dataIndex: "address",
      key: "address",
    },
  ];
  return (
    <div>
      <Input.Search
        placeholder="Search here ...."
        style={{
          marginBottom: 15,
          marginTop: 12,
          width: 300,
        }}
        onSearch={(value) => {
          setSearchText(value);
        }}
        onChange={(e) => {
          setSearchText(e.target.value);
        }}
      />
      <Table
        dataSource={dataSource.map((item) => ({ ...item, key: item.id }))}
        columns={columns}
      />
    </div>
  );
};

export default OrderTable;
